var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialMediaIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 340,
    height: 100,
    viewBox: "0 0 340 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1489",
    "data-name": "Group 1489",
    transform: "translate(-851 -535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M100,50A50,50,0,1,1,50,0a50,50,0,0,1,50,50",
    transform: "translate(851 535)",
    fill: "#30f9c0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M46.738,87.968c24.421,0,37.776-20.232,37.776-37.776q0-.862-.038-1.716A27.029,27.029,0,0,0,91.1,41.6a26.5,26.5,0,0,1-7.624,2.09,13.324,13.324,0,0,0,5.839-7.344,26.613,26.613,0,0,1-8.43,3.223A13.289,13.289,0,0,0,58.256,51.678,37.693,37.693,0,0,1,30.89,37.807,13.286,13.286,0,0,0,35,55.531a13.184,13.184,0,0,1-6.013-1.661c0,.056,0,.111,0,.17A13.284,13.284,0,0,0,39.636,67.056a13.264,13.264,0,0,1-6,.227,13.292,13.292,0,0,0,12.4,9.221,26.639,26.639,0,0,1-16.49,5.683A26.952,26.952,0,0,1,26.386,82a37.585,37.585,0,0,0,20.352,5.964",
    transform: "translate(844.159 525.829)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_468",
    "data-name": "Rectangle 468",
    width: 100,
    height: 100,
    transform: "translate(851 535)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M100,50A50,50,0,1,1,50,0a50,50,0,0,1,50,50",
    transform: "translate(971 535)",
    fill: "#30f9c0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M87.006,59.66,77.13,69.537H67.253l-8.641,8.642V69.537H47.5V32.5H87.006Z",
    transform: "translate(958.685 526.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M39.845,25.834,27.5,38.179V82.624H42.315V94.97L54.66,82.624h9.877L86.759,60.4V25.834Zm41.976,32.1-9.876,9.876H62.067l-8.641,8.642V67.809H42.315V30.772H81.821Z",
    transform: "translate(963.87 528.302)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 4.939,
    height: 14.815,
    transform: "translate(1033.346 567.716)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_470",
    "data-name": "Rectangle 470",
    width: 4.939,
    height: 14.815,
    transform: "translate(1019.765 567.716)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_471",
    "data-name": "Rectangle 471",
    width: 100,
    height: 100,
    transform: "translate(971 535)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M100,50A50,50,0,1,1,50,0a50,50,0,0,1,50,50",
    transform: "translate(1091 535)",
    fill: "#30f9c0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M89.511,66.721a37.029,37.029,0,0,0,0-24.37,2.433,2.433,0,0,0-.117-.333,37.037,37.037,0,0,0-69.714,0,2.337,2.337,0,0,0-.117.333,37.029,37.029,0,0,0,0,24.37,2.658,2.658,0,0,0,.117.334,37.037,37.037,0,0,0,69.714,0,2.443,2.443,0,0,0,.117-.334M54.537,86.264c-1.41,0-3.684-2.553-5.586-8.256a58.21,58.21,0,0,1-2.186-9.357H62.309a58.108,58.108,0,0,1-2.186,9.357c-1.9,5.7-4.176,8.256-5.586,8.256M46.121,63.343c-.256-2.83-.39-5.784-.39-8.807s.134-5.975.39-8.805H62.954c.254,2.83.389,5.782.389,8.805s-.135,5.976-.389,8.807Zm-23.31-8.807a31.587,31.587,0,0,1,1.244-8.805H40.8c-.249,2.889-.375,5.85-.375,8.805s.126,5.917.375,8.807H24.054a31.605,31.605,0,0,1-1.244-8.807M54.537,22.809c1.41,0,3.684,2.553,5.586,8.256a58.089,58.089,0,0,1,2.186,9.357H46.765a58.034,58.034,0,0,1,2.186-9.357c1.9-5.7,4.176-8.256,5.586-8.256M68.279,45.731H85.02a31.778,31.778,0,0,1,0,17.612H68.279c.249-2.89.373-5.85.373-8.807s-.124-5.916-.373-8.805m14.667-5.31H67.671c-.946-6.512-2.565-12.353-4.838-16.51a31.868,31.868,0,0,1,20.113,16.51m-36.7-16.51c-2.273,4.156-3.892,10-4.838,16.51H26.128a31.868,31.868,0,0,1,20.113-16.51M26.128,68.652H41.4c.946,6.513,2.565,12.354,4.838,16.51a31.874,31.874,0,0,1-20.113-16.51m36.7,16.51c2.273-4.156,3.892-10,4.838-16.51H82.946a31.874,31.874,0,0,1-20.113,16.51",
    transform: "translate(1086.463 530.463)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_472",
    "data-name": "Rectangle 472",
    width: 100,
    height: 100,
    transform: "translate(1091 535)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaIcons);
export default __webpack_public_path__ + "static/media/social-media-icons.ef68860e.svg";
export { ForwardRef as ReactComponent };